/**
 * Tab Group Component
 * A custom element that manages tab switching behavior with accordion-style content toggling.
 *
 * Usage:
 * <tab-group first-open>
 *   <button content-type="description">Description</button>
 *   <button content-type="details">Details</button>
 *   <tab-content>
 *     <div content-type="description">Description content</div>
 *     <div content-type="details" class="hidden">Details content</div>
 *   </tab-content>
 * </tab-group>
 */
if (!customElements.get('tab-group')) {
  customElements.define(
    'tab-group',
    class TabGroup extends HTMLElement {
      constructor() {
        super();
        this.isFirstOpen = this.hasAttribute('first-open');
        this.contentContainer = this.querySelector('tab-content');
        this.buttons = this.querySelectorAll('button');
      }

      connectedCallback() {
        this.openFirstDetails();
        this.ensureSingleOpenDetails();
      }

      openFirstDetails() {
        if (this.isFirstOpen && this.contentContainer && this.buttons.length > 0) {
          const firstContent = this.contentContainer.firstElementChild;
          if (firstContent) {
            firstContent.classList.remove('hidden');
          }
          this.buttons[0].classList.add('!border-brand-secondary-200');
        }
      }

      ensureSingleOpenDetails() {
        const staticButtons = this.querySelectorAll('button');
        staticButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            const buttonID = event.target.getAttribute('content-type');
            event.target.classList.add('!border-brand-secondary-200');
            const content = this.contentContainer.querySelector(`[content-type="${buttonID}"]`);
            event.preventDefault();

            if (content) {
              content.classList.remove('hidden');
            }

            staticButtons.forEach((btn) => {
              if (event.target !== btn) {
                btn.classList.remove('!border-brand-secondary-200');
              }
            });

            if (content && this.contentContainer) {
              Array.from(this.contentContainer.children).forEach((el) => {
                if (el !== content && !el.classList.contains('hidden')) {
                  el.classList.add('hidden');
                }
              });
            }
          });
        });
      }
    }
  );
}
